import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import International from "./components/International/International";
import Domestic from "./components/Domestic/Domestic";
import About from "./components/About/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Cruise from "./components/Cruise/cruise";
import "./App.css";

function App() {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag("config", "G-XXXXXXXXXX", {
        page_path: location.pathname,
      });
    }
  }, [location]);
  return (
    <>
      <Navbar />
      <div className="page">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/international" element={<International />} />
          <Route path="/domestic" element={<Domestic />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/cruise" element={<Cruise />} />
        </Routes>
      </div>
      <Footer />
    </>
  );
}

export default App;
